// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
    company: {
      display: 'flex',
      paddingTop: 20,
      paddingBottom: 10,
      paddingRight: 0,
      paddingLeft: 10,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    companyCloseDrawer: {
      justifyContent: 'center',
    },
    logoContainer: {
      minWidth: 50,
      width: 50,
      height: 50,
      position: 'relative',
      cursor: 'pointer',
      borderRadius: '10%',
      border: 'none',
      backgroundColor: theme.palette.colors.green,
      '& img': {
        position: 'absolute',
        borderRadius: '10%',
        height: '100%',
        width: '100%',
        border: 'none',
        transition: theme.transitions.create('all', {
          easing: theme.transitions.easing.sharp,
          duration: 800,
        }),
      },
    },
    logoUpdate: {
      padding: '20%',
      boxSizing: 'border-box',
      background: 'rgba(0, 0, 0, 0.6)',
    },
    hiddenImage: {
      opacity: 0,
    },
    companyLabel: {
      fontSize: 16,
      fontWeight: 'bold',
      marginLeft: 7,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: theme.palette.colors.white,
    },
    companyLabelDrawerClose: {
      display: 'none',
    },
    settings: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.colors.white,
      marginBottom: 20,
    },
    settingsDawerClose: {
      justifyContent: 'center',
    },
    settingsIcon: {
      width: 35,
      height: 30,
      color: theme.palette.colors.white,
    },
    settingsText: {
      fontSize: 14,
      marginTop: 3,
      textTransform: 'none',
      color: theme.palette.colors.white,
      marginLeft: theme.spacing(1),
      overflow: 'hidden',
    },
    marginIcon: {
      marginLeft: 5,
    },
  }),
);

export default useStyles;
